import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import classNames from 'classnames';
import { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import NOLItemList from '/@/components/new-overlay-list/item-list';
import settings from '/@/core/settings';
import { useAnchorEl } from '/@/hooks/anchor-el/useAnchorEl';
import { _ } from '/@/locale';
import { checkInternal } from '/@/settings/menu.js';
import { resetProductSelection } from '/@/store/catalog/actions';
import { useCatalogConfig } from '/@/store/catalog/apiProviders';
import { getAppInstance, getUser } from '/@/store/session/selectors';
import type { Brand } from '/@/types/catalog';
import { reverse } from '/@/utils/router';
import Title from '/@/v3/components/title';
import styles from './styles.module.css';

const BrandDisplay = ({ brand, isLogin, children }: { brand: Brand; isLogin: boolean; children: React.ReactNode }) => {
    const dispatch = useDispatch();
    const { data: config } = useCatalogConfig({ brand: brand.id });
    const user = useSelector(getUser);
    const appInstance = useSelector(getAppInstance);
    const history = useNavigate();
    const [{ open, anchorEl }, { handleClick: handleOpenOptions, handleClose: handleClosePopover }] = useAnchorEl();

    // This is to avoid display de label "Refuge" which makes no sense. Instead it displays the brand name.
    const brandLabel = brand.name === 'Refúgio Max' ? 'Refúgio Max' : settings.enums.brandTypes[brand.type].label;

    const id = open ? 'simple-popover' : undefined;

    const handleClick = (e, catalogType) => {
        dispatch(resetProductSelection());
        const type = e.type;
        const slug = e.slug;
        history(
            reverse('catalog.ProductSelection', {
                params: {
                    type,
                    slug,
                    internal: catalogType == 'internal' ? 'bayer' : 'catalog',
                },
            })
        );
    };

    const overlayConfig = [
        {
            label: _('Catálogo de Productos Bayer'),
            icon: 'bayer',
            enable: true,
            id: 'cropProtection',
            onClick: (e) => handleClick(e),
        },
        {
            label: _('Perfil Interno'),
            icon: 'bayer',
            enable: true,
            id: 'internalProfile',
            onClick: (e) => {
                handleClick(e, 'internal');
            },
        },
    ];

    return (
        <Fragment>
            <div className={classNames(styles.loginBrand, !isLogin && styles.rowDisplay)}>
                <div className={styles.logoContainer}>
                    <img onClick={() => handleClick(brand)} className={styles.circleLogo} src={brand.logo} />
                </div>
                {children}
                <div className={!isLogin && styles.text}>
                    <Title
                        color={isLogin && 'light'}
                        className={styles.cropLogin}
                        theme={!isLogin && settings.app.theme}
                        bolder={!isLogin}
                    >
                        {brandLabel}
                    </Title>
                    {!isLogin && (
                        <div>
                            <Title color='light' className={classNames(styles.description, styles.cropLogin)}>
                                {config && _(config.listDescription)}
                            </Title>
                            {brand.type === 'crop_protection' &&
                            appInstance.enableInternalProfileCatalog &&
                            checkInternal(user, appInstance) ? (
                                <div>
                                    <Button variant='contained' onClick={handleOpenOptions} fullWidth sx={{ my: 2 }}>
                                        {_('Acceder')}
                                    </Button>
                                    <Popover
                                        id={id}
                                        open={open}
                                        anchorEl={anchorEl}
                                        onClose={handleClosePopover}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                    >
                                        <NOLItemList
                                            myRecommendations
                                            itemList={overlayConfig}
                                            selectItem={(e) => {
                                                e.onClick(brand);
                                            }}
                                        />
                                    </Popover>
                                </div>
                            ) : (
                                <Button variant='contained' onClick={() => handleClick(brand)} fullWidth sx={{ my: 2 }}>
                                    {_('Acceder')}
                                </Button>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Fragment>
    );
};

export default BrandDisplay;
